
































import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { HeadMenu } from '@/constants/constants';
import { GPageBase } from '@/mixins';

@Component({
  name: 'GPromotionCompleteModal',
  computed: {},
  methods: {},
})
export default class GPromotionCompleteModal extends Mixins(GPageBase) {
  showConfirmModal: boolean = false;

  @Prop({ default: false }) value: boolean;
  @Watch('value')
  openModal(value: boolean) {
    this.showConfirmModal = value;
  }

  async mounted() {}

  handleCompleteOK() {
    window.location.reload();
  }

  handleOpenManualWindow() {
    window.open(
      this.$t('AIGROW_MANUAL_URL_PROMOTION_2').toString(),
      'popupWindow',
      'width=740,height=800,noopener,noreferrer'
    );
  }
}
